import React from 'react';
import { CheckCircle } from 'lucide-react';
import { personalInfo } from '../data/mock';

const About = () => {
  const highlights = [
    "7+ years of experience in digital marketing",
    "AI-driven SEO and GEO specialist",
    "Expert in Google Analytics, SEMrush, and paid advertising platforms",
    "Proven track record of increasing organic traffic by up to 60%",
    "Skilled in CRO techniques and conversion optimization",
    "Experience managing CRM systems (HubSpot) and marketing automation"
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">About Me</h2>
            <div className="w-20 h-1 bg-gray-900 mx-auto"></div>
          </div>

          <div className="space-y-8">
            <p className="text-xl text-gray-700 leading-relaxed">
              {personalInfo.summary}
            </p>

            <div className="bg-gray-50 rounded-xl p-8 space-y-4">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Core Competencies</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {highlights.map((highlight, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-700 text-lg">{highlight}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="pt-8">
              <p className="text-lg text-gray-700 leading-relaxed">
                I specialize in developing comprehensive digital marketing strategies that combine
                technical expertise with creative thinking. My approach is data-driven, focusing on
                measurable results and continuous optimization. Whether it's pioneering Generative
                Engine Optimization (GEO) strategies or streamlining B2B lead acquisition, I bring
                a wealth of experience and a fresh perspective to every project.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;